import React from 'react';
import Hero from '../components/hero';
import FeaturedProjects from '../components/featuredProjects';
import Services from '../components/services';
import TechStack from '../components/techStack';
import zeina from '../assets/reference/zeina.png';
import useSectionNavigation from '../hooks/useSectionNavigation';
import './home.css';

export default function Home() {
  const navigateToSection = useSectionNavigation();
  return <div className="home" id="home">
    <Hero portraitSrc={zeina} onExplore={() => navigateToSection('#projects')} />
    <FeaturedProjects />
    <Services />
    <TechStack />
  </div>;
}
